module.exports = __webpack_public_path__ + "img/男排、女排.7bae9a67.jpg";